<template>
  <el-form
    class="form"
    size="small"
    label-position="right"
    label-width="100px"
    :rules="rules"
    :model="examForm"
    ref="examForm"
  >
    <el-row>
      <el-col :span="12">
        <el-form-item label="调查类型：" required>
          <el-radio-group
            :disabled="edit"
            v-model="examForm.investigationType"
            @change="examTypeChange"
          >
            <el-radio
              v-for="item in examTypeData"
              :key="item.paramKey"
              :label="item.paramKey"
              >{{ item.paramValue }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="examForm.investigationType == 0">
      <el-col :span="12">
        <el-form-item label="班级名称：" prop="bizId">
          <load-select
            v-if="!edit"
            class="form-select"
            v-model="examForm.bizId"
            dictLabel="className"
            dictValue="uuid"
            :data="data"
            :page="page"
            :hasMore="more"
            :request="getData"
            placeholder="请选择班级（输入班级名称关键字以查询）"
          />
          <el-input v-else :value="examForm.className" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="问卷名称：" required prop="questionnaireId">
          <load-select
            v-if="!edit"
            class="form-select"
            v-model="examForm.questionnaireId"
            dictLabel="questionnaireName"
            dictValue="uuid"
            :data="idata"
            :page="ipage"
            :hasMore="imore"
            :request="getiData"
            placeholder="请选择问卷（输入问卷名称关键字以查询）"
          />
          <el-input
            v-else
            :value="examForm.questionnaireName"
            disabled
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12"
        ><el-form-item label="限制时间：" prop="isLimitTime" required>
          <el-radio-group v-model="examForm.isLimitTime">
            <el-radio
              v-for="item in publicData"
              :key="item.paramKey"
              :label="item.paramKey"
              >{{ item.paramValue }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12"
        ><el-form-item
          label="调查时间："
          prop="examTime"
          :required="examForm.isLimitTime == 1"
        >
          <el-date-picker
            unlink-panels
            v-model="examForm.examTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd HH:mm"
            :picker-options="examOptions"
            :disabled="examForm.isLimitTime == 0"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import moment from "moment";
import { Confirm } from "@/components/Confirm";
import { getPublishedInvesList } from "@/api/questionnaire";
import { getPublishedClassList } from "@/api/class";
import { saveInvestigation, updateInvestigation } from "@/api/investigation";
import LoadSelect from "@/components/load-select/index.vue";
import { setItem } from "@/utils/storage.js";

export default {
  components: {
    LoadSelect,
  },
  props: {
    examTypeData: {
      type: Array,
      default: () => [],
    },
    publicData: {
      type: Array,
      default: () => [],
    },
    edit: { type: Boolean, default: false },
  },
  data() {
    let that = this;
    return {
      page: 1,
      more: true,
      data: [],
      ipage: 1,
      imore: true,
      idata: [],
      examForm: {
        investigationType: 0,
        bizId: "",
        questionnaireId: "",
        isLimitTime: 0,
        examTime: [],
      },
      rules: {
        questionnaireId: [
          {
            required: true,
            message: "请选择问卷",
            trigger: ["blur", "change"],
          },
        ],
        examTime: [
          {
            validator: (rule, value, callback) => {
              if (that.$data.examForm.isLimitTime == 0) {
                callback();
              } else {
                if (value.length === 0) {
                  callback(new Error("请选择调查时间"));
                } else if (moment(value[0]) < new Date().getTime()) {
                  callback(new Error("调查时间不能早于当前时间"));
                } else {
                  callback();
                }
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
      classData: [],
      paperData: [],
      totalScore: 60,
      examOptions: {
        disabledDate(date) {
          return moment().subtract(1, "days") >= date.getTime();
        },
      },
    };
  },
  methods: {
    getiData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getPublishedInvesList({
          page,
          questionnaireName: keyword,
          publishStatus: 1,
        }).then(({ code, data }) => {
          if (code !== 0) return;
          if (more) {
            this.idata = [...this.idata, ...data.records];
          } else {
            this.idata = data.records;
          }
          this.ipage = data.current;
          let { current, total, size } = data;
          this.imore = current * size < total;
          this.ipage = current;
          resolve();
        });
      });
    },
    getData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getPublishedClassList({
          page,
          className: keyword,
        }).then(({ code, data }) => {
          if (code !== 0) return;
          if (more) {
            this.data = [...this.data, ...data.records];
          } else {
            this.data = data.records;
          }
          this.page = data.current;
          let { current, total, size } = data;
          this.more = current * size < total;
          this.page = current;
          resolve();
        });
      });
    },
    // 调查类型改变
    examTypeChange(val) {
      this.$emit("changeExamType", val);
    },
    // 根据名称搜索问卷
    searchPaper(query) {
      getPublishedInvesList({ questionnaireName: query }).then((res) => {
        if (!res || res.code != 0) return;
        this.paperData = res.data;
      });
    },
    // 重置
    reset() {
      if (this.edit) {
        Object.assign(this.examForm, {
          isLimitTime: 0,
          examTime: [],
        });
      } else {
        this.$refs["examForm"].resetFields();
      }
    },
    submit(val) {
      this.$refs["examForm"].validate((res) => {
        if (res) {
          let params = {
            investigationType: this.examForm.investigationType,
            bizId: this.examForm.bizId,
            isLimitTime: this.examForm.isLimitTime,
          };
          if (this.examForm.isLimitTime) {
            params["limitStartTime"] = moment(this.examForm.examTime[0]).format(
              "YYYY-MM-DD HH:mm"
            );
            params["limitEndTime"] = moment(this.examForm.examTime[1]).format(
              "YYYY-MM-DD HH:mm"
            );
          }
          if (this.edit) {
            params["uuid"] = val;
            params["questionnaireId"] = this.examForm.questionnaireId;
            updateInvestigation(params).then((res) => {
              if (!res || res.code != 0) return;
              this.$message({
                message: "编辑成功",
                type: "success",
              });
              setItem(this.REFRESH_FLAG, true);
              this.$router.back();
            });
          } else {
            params["questionnaireId"] = this.examForm.questionnaireId;
            saveInvestigation(params).then((res) => {
              if (!res || res.code != 0) return;
              this.$message({
                message: "新增调查成功",
                type: "success",
              });
              if (params.investigationType == 1) {
                this.successAction(res.data);
              } else {
                setItem(this.REFRESH_FLAG, true);
                this.$router.back();
              }
            });
          }
        }
      });
    },
    successAction(examId) {
      const text = "成功创建定向调查，需要继续进行调查学员选择吗？";
      Confirm(text, "成功创建调查", {
        confirmButtonText: "立即选择",
        cancelButtonText: "以后再说",
        type: "warning",
      })
        .then(() => {
          this.$emit("selectStudents", examId);
        })
        .catch(() => {
          this.$router.back();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  .el-select {
    width: 100%;
  }
  .el-date-editor--datetimerange {
    width: 100%;
  }
  .el-input-number {
    width: 100%;
  }
}
</style>
